export let pagination = {
  count: 0,
  total: 0,
  current_page: 0,
  total_pages: 0,
  per_page: 0
}

export let company = () => {
  let company = {
    name: null,
    email_support: null,
    billing_options: [],
    documents: []
  }

  return Object.assign({}, company)
}

export let contract = () => {
  let contract = {
    uuid: null,
    company: company()
  }

  return Object.assign({}, contract)
}

export let orderTemplate = {
  uuid: null,
  code: null,
  sum: null,
  duration: null,
  contract: contract()
}

export let modal = (open = false, data = {}) => {
  let modal = {open, data}

  return JSON.parse(JSON.stringify(modal))
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/dataTemplates.js